import { PermissionsService } from '../../services/account/permissions.service';
import { IPermissionLevel } from '../../models/security/permission-level';
import { Directive, ElementRef } from '@angular/core';

interface IPdsScope  {
    atrDateformat: string;
}
@Directive({
    selector: '[pdsHasAccess]'
})
export class PdsHasAccessDirective {
    constructor(permissionsService: PermissionsService, element: ElementRef) {
        /*return {
            restrict: 'A',

            link: (scope: IPdsScope/*, element: ng.IAugmented, attributes: ng.IAttributes*///): void => {

                /*
                let key = attributes["pdsHasAccess"].split('|');

                let permissionLevel: IPermissionLevel = permissionsService.getCurrentTabPermissionViaState(key[0], key[1]);

                let noAccess = permissionLevel <= IPermissionLevel.canRead;

                if (noAccess === true) {
                    element.attr("disabled", "disabled");
                }
                else {
                    element.removeAttr("disabled");
                }

                if (element[0].tagName === "A" || element[0].tagName === "SPAN") {
                    if (noAccess === true) {
                        element.addClass("disabled");
                    }
                    else {
                        element.removeClass("disabled");
                    }
                }*/
            //}
        //};
    }
}